import React from 'react';

const PageFooter = () => {
    const currentYear = new Date().getFullYear();
    return <div className="page-footer">&copy; {currentYear} Verizon</div>;
};

export default PageFooter;
